import {
  REGIONAL_PLAN_COPY_APPROVAL_TYPE,
  REGIONAL_PLAN_NEW_ELEVATION_APPROVAL_TYPE,
} from 'src/constants/regionalPlanApprovals.constants'
import {
  RegionalApprovalRow,
  RegionalPlanApprovalData,
  RegionalPlanNewElevationRequestData,
} from 'src/types/plan.interface'

/** Anything that may carry the approvalsV2 discriminator. */
interface HasApprovalType {
  approvalType?: string
}

/**
 * Type guards over the approvalsV2 discriminator. Legacy core-copy approvals
 * never carry approvalType; regional plan copy approvals and new-elevation
 * requests share the container, the fetch endpoints and the SignalR channel,
 * so every consumer narrows with these rather than re-reading the field.
 */
export const isRegionalPlanCopyApproval = <T extends HasApprovalType>(
  candidate: T | undefined
): candidate is T & RegionalPlanApprovalData =>
  candidate?.approvalType === REGIONAL_PLAN_COPY_APPROVAL_TYPE

export const isRegionalPlanNewElevationRequest = <T extends HasApprovalType>(
  candidate: T | undefined
): candidate is T & RegionalPlanNewElevationRequestData =>
  candidate?.approvalType === REGIONAL_PLAN_NEW_ELEVATION_APPROVAL_TYPE

/** True for either regional document; false for legacy core-copy approvals. */
export const isRegionalApproval = <T extends HasApprovalType>(
  candidate: T | undefined
): candidate is T & RegionalApprovalRow =>
  isRegionalPlanCopyApproval(candidate) ||
  isRegionalPlanNewElevationRequest(candidate)
